




import { defineComponent } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import PayeeInfoEditView from "@/views/PagePayeeInfoEdit/components/PayeeInfoEditView.vue";

export default defineComponent({
  name: "PagePayeeInfoEdit",
  components: {
    PayeeInfoEditView,
  },
  setup() {
    const { userVerified } = useAuthUser();
    return {
      userVerified,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      if (!vm.userVerified) {
        vm.$router.replace(from);
      }
    });
  },
});
